import React, {useEffect, useState, useCallback, useRef} from "react";
import { getCollections, getContractAdminCollections, getCollectionById } from "../../../lib/api";
import {useAppKit, useAppKitAccount, useAppKitProvider} from '@reown/appkit/react'
import chainData from "../../../chains.js"
import {ethers} from 'ethers'

import {getDataForChain} from "../../../utils/index.js";
import {useAppKitNetwork} from "@reown/appkit/react";

const abi = [
    'function nftIds(uint256 a) view returns(uint256)',
    'function newERC721(string TokenName, string Symbol, address collectionOwner, string baseURI, uint256 defMintFee)',
    'function newND721((string tname,string symbol,uint256 maxsupp,uint256 rpool,uint256 secroy,string tokuri,uint256 price,uint256 flags,address owner,uint256 wldiscount,address impl,address rmimpl))',
    'function defImplementation() view returns(address)',
    'function defRMImplementation() view returns(address)',
    'function usersTokensLen(address) view returns(uint256 count)',
    'function freeMintNFT(uint256, address, uint256[])',
    'function tokensByAddress(address) view returns (tuple(address NFTProxyAddr, address RMProxyAddrstring, string tokenName, string tokenSymbol, string tokenType, address NFTImpl, address RMImpl)[])',
    'function tokenByAddress(address, uint256) view returns (tuple(address NFTProxyAddr, address RMProxyAddrstring, string tokenName, string tokenSymbol, string tokenType, address NFTImpl, address RMImpl))',
    'function NFTConfiguratorAddr() view returns(address cfg)',
    'function String_ContractState(address ctr, string memory value, bool immediate)',
    'function tokenURI(uint256 tid) view returns(string)',
];

/**
 * CategoryCard component (Management DeployedCollections).
 *
 * Displays user's NFT collections and upload status:
 * - Shows items count in selected collection
 * - Shows queued files count for upload
 * - Upload to Server button (if files queued)
 * - Create/Update NFT button (if collection selected with items)
 * - Collapsible list of collections from:
 *   - On-chain deployed contracts (via wallet provider)
 *   - Backend collections (via API)
 *
 * Handles collection selection and navigation to management forms.
 *
 * @param {Object} props - Component props
 * @param {Object} props.cData - Currently selected collection data
 * @param {number} props.flen - Number of files queued for upload
 * @param {React.ReactNode} props.ulButton - Upload to Server button
 * @param {React.ReactNode} props.deButton - Create/Update NFT button
 * @param {Function} props.goToCollection - Navigation to collection page
 * @param {Function} props.clickCallback - Opens management form (e.g., "manageEVM")
 * @param {Function} props.setCInfo - Setter for cData
 * @param {number} props.signalUpdate - Trigger to refetch collections
 * @returns {React.ReactElement} Deployed collections panel
 */
const CategoryCard = ({
                          cData,
                          flen,
                          ulButton,
                          deButton,
                          goToCollection,
                          clickCallback,
                          setCInfo,
                          signalUpdate
                      }) => {

    const [itemsData, setID] = useState({});
    const {wallet, open, close} =  useAppKit()
    const [colls, setColls] = useState([])
    const [colls2, setColls2] = useState([])
    const [cd, scd] = useState({})
    const { walletProvider } = useAppKitProvider("eip155");
    const { chainId } = useAppKitNetwork();
    const {isConnected, address} = useAppKitAccount();
    const cListRef = useRef(null);

    // Derived values instead of state to reduce re-renders
    const ulb = flen > 0 ? ulButton : null;
    const deb = (itemsData && itemsData.ct > 0) ? deButton : null;


    const GetCollections = useCallback(async () => {
        // Use the provider from the user's wallet. It will be null if not connected.
        if (isConnected && walletProvider) {
            // establish what chain we're on

            // Create a new ethers provider that wraps the wallet's provider.
            const provider = new ethers.providers.Web3Provider(walletProvider);
            // If you need to send transactions, you'll need a signer.
            const signer = provider.getSigner();

            let chainInf = getDataForChain(chainId.toString(16))
            scd(chainInf?.data)

            // Create the contract instance using the wallet's provider (or signer for transactions).
            // This ensures all contract calls go through the user's wallet and respect the selected chain.
            if (chainInf?.data?.nftDeployer) {
                let ctr = new ethers.Contract(chainInf.data.nftDeployer, abi, provider)

                ctr.tokensByAddress(address)
                    .then(res => {
                        setColls(res)
                    })
                    .catch(e => {
                    })
            }

            let ctrTmp = []
            try {
                const res = await getCollections({ net: "1", fromWallet: address });
                if (res?.data) ctrTmp = [...ctrTmp, ...res.data];
            } catch (e) {
                console.error('Failed to fetch collections by wallet:', e);
            }
            try {
                // Use address directly to avoid dependency on wallet object structure
                const r = await getContractAdminCollections({ walAddr: address });
                if (r) ctrTmp = [...ctrTmp, ...r];
            } catch (e) {
                console.error('Failed to fetch contract admin collections:', e);
            }
            setColls2(ctrTmp)
        }
    }, [isConnected, walletProvider, chainId, address]);

    useEffect(() => {
        GetCollections()
    }, [GetCollections, signalUpdate])

    useEffect(() => {
        if (cData?.meta?.coll_id !== undefined) {
            getCollectionById(cData.meta.coll_id)
                .then((poo) => {
                    setID(poo)
                })
                .catch(err => {
                    console.error('Failed to fetch collection info:', err);
                });
        }
    }, [cData?.meta?.coll_id])

    function togglecList(){
        if (cListRef.current) {
            cListRef.current.className = cListRef.current.className === "collListCollapse" ? "collListShow" : "collListCollapse";
        }
    }

    if (itemsData && itemsData.ct !== undefined) {

        return (
            <div className="card card-purple h-100 mb-30">
                <div className="card-header pb-0 p-3">
                    <h6 className="mb-0">-Your Collections</h6>
                </div>
                <div className="card-body p-3" style={{color: "green"}}>
                    <h6 onClick={() => goToCollection(1)} style={{textDecoration: "underline"}}
                        className="text-uppercase text-body text-xs font-weight-bolder">Items in this
                        Collection: {itemsData.ct}</h6>
                    <h6 className="text-uppercase text-body text-xs font-weight-bolder">Queued for
                        uploading: {flen}</h6>
                    <div style={{color: "green"}}>
                        {ulb}
                        {deb}
                    </div>

                    <h6 className="text-uppercase text-body text-xs font-weight-bolder mt-4">Collection
                        Category</h6>

                    {/*<h6 className="text-uppercase text-body text-xs font-weight-bolder mt-4">Blockchain Based </h6>*/}

                </div>
            </div>
        );
    } else {
        return (
            <>
                <div onClick={()=>togglecList()} className="card card-purple h-100 mb-1 pt-3 px-2">
                    <div style={{textAlign: "center"}} className="raisedBoxPurple card-purple pb-0 p-1 mb-3 ">
                        <h6 className="mb-0 text-light">YourCollections_ on {cd?.chainName} ({colls.length+colls2.length})</h6>
                    </div>

                    <div ref={cListRef} className="collListCollapse" style={{color: "green"}}>
                    <div className="card-body p-1">
                        {colls.slice(0).reverse().map((item, id) =>
                            <div key={item.NFTProxyAddr || id} className="" onClick={() => {
                                setCInfo(item);
                                clickCallback("manageEVM")
                            }}>
                                <div style={{display: "flex", flexDirection: "row"}}>
                                    <div style={{flex: 1}}
                                         className="text-bold">{item.tokenName}({item.tokenSymbol})
                                        <div style={{paddingTop: "3px", fontSize: "10px", fontFamily: "monospace"}}>{item.NFTProxyAddr}</div>
                                    </div>

                                </div>


                            </div>)
                        }
                        <hr/>
                        {colls2.map((item, id) =>
                            <div key={item.contractAddress || id}
                                style={{color: "green"}}
                                onClick={() => {
                                    setCInfo(item);
                                    clickCallback("manageEVM")
                                }}>{item.symbol} ({item.name})<br/>{item.contractAddress}
                            </div>)
                        }
                        {/*<h6  className="text-light text-xs font-weight-bolder">No collection is selected, please use the dropdown to select, search for, or create a new collection.</h6>*/}

                        {/*<h6 className="text-uppercase text-body text-xs font-weight-bolder mt-4">Blockchain Based </h6>*/}

                    </div>
                </div>
                </div>
            </>
        );
    }
}

export default CategoryCard;

// function freeMint(contractAddr) {
//     if (wallet) {
//         let cw = new callWrapper("console", {rpcUrl: chainData[1].rpc, chainId: chainData[1].chainId})
//         let signer = (new ethers.providers.Web3Provider(wallet.provider)).getSigner()
//         let ctr = new ethers.Contract(contractAddr, abi, signer)
//         let a = [];
//         let options = {gasLimit: 8000000, value: 0};
//         let data = cw.call(ctr.freeMintNFT(1, wallet.accounts[0].address, a, options), "freeMintNFT")
//             .then(res => {
//                 console.log(res);
//                 //setColls(res)
//             })
//     } else {
//         toast("Connect wallet")
//     }
// }
